import angular from 'angular';
import StreamPrintLogoDirective from './stream-print-logo.directive';

let StreamPrintLogoModule = angular.module('stream-print-logo-module', [])

    .directive('streamPrintLogo', StreamPrintLogoDirective)

    .name;

export default StreamPrintLogoModule;


// WEBPACK FOOTER //
// ./client/app/common/stream-print-logo/index.js